import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import { deleteStaffApi } from "../../../services/apis/EventMangement/EventStaffApi";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteCreateEvent,
  deleteEvent,
  getAllEventApi,
  UpdateEventStatus,
} from "../../../services/apis/EventMangement/CreateEventApi";
import Switch from "react-switch";
import moment from "moment";
import apis from "../../../services/apis";
import logo from "../../../assets/images/profile/1.jpg";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Logo", sortingVale: "logo" },
  { heading: "Name", sortingVale: "name" },
  { heading: "Type", sortingVale: "type" },
  { heading: "Event Status", sortingVale: "event_status" },
  { heading: "Start Date", sortingVale: "start_date" },
  { heading: "End Date", sortingVale: "end_date" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const AllEvents = () => {
  const navigate = useNavigate();
  const [sort, setSortata] = useState(10);
  const [loading, setLoading] = useState(false);

  const [allEventList, setAllEventList] = useState([]);

  const [showDeleteMdl, setShowDeleteMdl] = useState(false);
  const [deleteTableDataId, setDeleteTableDataId] = useState("");

  const getAllEventList = async () => {
    setLoading(true);
    try {
      const response = await getAllEventApi();
      if (response.data.success) {
        setAllEventList(response?.data?.events);
      }
    } catch (error) {
      console.error("Error fetching cuisines:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllEventList();
  }, []);

  const handleDeleteSubmit = async () => {
    try {
      const res = await deleteCreateEvent(deleteTableDataId);
      if (res.status === 201) {
        toast.success(res?.data?.message, {
          position: "top-center",
        });
        getAllEventList();
        setDeleteTableDataId("");
        setShowDeleteMdl(false);
      } else {
        toast.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-my-event/${id}`);
  };

  const handleDelete = (id) => {
    setDeleteTableDataId(id);
    setShowDeleteMdl(true);
  };

  const handleStatusChange = async (Id, currentStatus) => {
    // const fdata = {
    //     status: !currentStatus
    // }

    try {
      const res = await UpdateEventStatus(Id);
      if (res?.data?.success) {
        toast.success(res?.data?.message, {
          position: "top-center",
        }); // Display success message
        getAllEventList();
      } else {
        toast.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <DeleteWarningMdl
        title={"selected table data"}
        showDeleteMdl={showDeleteMdl}
        setShowDeleteMdl={setShowDeleteMdl}
        setDeleteTableDataId={setDeleteTableDataId}
        handleDeleteSubmit={handleDeleteSubmit}
      />

      <ToastContainer />

      <Loader visible={loading} />

      <PageTitle
        activeMenu={"All Events"}
        motherMenu={"Home"}
        motherMenuLink={"/dashboard"}
      />

      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Events</h4>
              <button
                className="btn btn-primary"
                onClick={() => navigate("/create-my-event")}
              >
                Create My Event
              </button>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setSortata("2")}>
                              2
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("5")}>
                              5
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("10")}>
                              10
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("15")}>
                              15
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => setSortata("20")}>
                              20
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search :
                        <input type="search" className="" placeholder="" />
                      </label>
                    </div>
                  </div>

                  <table
                    id="example4"
                    className="display dataTable no-footer w-100"
                  >
                    <thead>
                      <tr>
                        {theadData?.map((item, ind) => {
                          return (
                            <th key={ind}>
                              {item.heading}
                              <span>
                                <i
                                  className="fa fa-arrow-down ms-2 fs-12"
                                  style={{ opacity: "0.7" }}
                                />
                              </span>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {allEventList?.map((data, ind) => (
                        <tr key={ind}>
                          <td>{ind + 1}</td>

                          <Link
                            to={`/attendee-list/${"677785663c6abe7adce6c0aa"}`}>
                            <td className="d-flex align-items-center gap-2 cursor-pointer">
                              <img
                                className="event-logo-img"
                                src={
                                  data?.thumbnail_path
                                    ? `${apis?.baseurl?.Baseimageurl}${data?.thumbnail_path}`
                                    : logo
                                }
                              />
                            </td>
                          </Link>
                          <td
                            className="cursor-pointer"
                            onClick={() =>
                              navigate(
                                `/attendee-list/${"677785663c6abe7adce6c0aa"}`
                              )
                            }>
                            {data?.event_title}
                          </td>

                          <td>{data?.event_type}</td>

                          <td>{data?.event_status}</td>

                          <td>
                            {moment(data?.start_date).format("DD MMM YYYY")}
                          </td>

                          <td>
                            {moment(data?.end_date).format("DD MMM YYYY")}
                          </td>

                          <td>
                            <td>
                              <Switch
                                checked={data?.status}
                                onChange={() =>
                                  handleStatusChange(data?._id, data?.status)
                                }
                                offColor="#f0f1ff"
                                onColor="#6a73fa"
                                offHandleColor="#6a73fa"
                                onHandleColor="#fff"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                width={40} // Adjust width of the switch
                                height={20} // Adjust height of the switch
                              />
                            </td>
                          </td>

                          <td>
                            <button
                              className="btn btn-xs sharp btn-primary me-1"
                              onClick={() => handleEdit(data?._id)}
                            >
                              <i className="fa fa-pencil" />
                            </button>

                            <button
                              className="btn btn-xs sharp btn-danger"
                              onClick={() => handleDelete(data?._id)}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AllEvents;
